var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.$t('tracking.pageTitle')))]),_c('ts-breadcrumb',{attrs:{"items":[
        { text: _vm.$t('home'), href: '/' },
        {
          text: _vm.$t('tracking.pageTitle'),
          active: true
        }
      ]}})],1),_c('ts-card',[_c('a-tabs',{attrs:{"default-active-key":_vm.key},on:{"change":_vm.onTableChange}},[_c('a-tab-pane',{key:1,attrs:{"tab":_vm.$t('tracking.historyPath'),"force-render":""}},[(_vm.key === 1)?_c('locationPath',{ref:"location"}):_vm._e()],1),_c('a-tab-pane',{key:2,attrs:{"tab":_vm.$t('tracking.nearest')}},[(_vm.key === 2)?_c('nearest'):_vm._e()],1),_c('a-tab-pane',{key:3,attrs:{"tab":_vm.$t('tracking.visitHistory')}},[(_vm.key === 3)?_c('viewHistory'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }